
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 30 19.97"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"handshake(1)","fill":"#cecece"}},[_c('path',{attrs:{"data-name":"Path 7148","d":"M10.854 2.893H6.162l-2.3 7.6a70 70 0 0010.608 9.336.722.722 0 00.93-1.1l-1.26-1.26-1.44-1.44a.6.6 0 01.846-.846l3.354 3.354a.936.936 0 001.328-1.31l-2.964-3.066a.6.6 0 01.018-.852.6.6 0 01.846.018l.474.486 2.49 2.58.666.684a.983.983 0 001.686-.66 1 1 0 00-.3-.726l-2.216-2.154-1.464-1.416a.6.6 0 01.834-.858l4.3 4.158a.907.907 0 001.27-.007.875.875 0 00.276-.666.907.907 0 00-.3-.66l-8.136-7.445a5.6 5.6 0 00-2.544 1.536.441.441 0 01-.114.1c-2.232 1.446-3.546.276-3.6.228-1.182-1.074-.618-2.766-.1-3.6a12.606 12.606 0 011.506-2.01z"}}),_c('path',{attrs:{"data-name":"Path 7149","d":"M16.728 1.627a2.7 2.7 0 00-1.938-.042 8.846 8.846 0 00-4.425 3.948c-.012.018-.852 1.41-.108 2.082.018.018.708.558 2.082-.312a6.327 6.327 0 013.51-1.89.6.6 0 01.462.156l8.34 7.638c.006 0 .006 0 .006.006a2.548 2.548 0 001.374-1.062l-2.94-7.992z"}}),_c('path',{attrs:{"data-name":"Path 7150","d":"M29.34 1.567a17.932 17.932 0 00-4.9.93.686.686 0 00-.36.864l3.552 9.648a.7.7 0 00.648.45h1.1a.617.617 0 00.618-.618V2.179a.608.608 0 00-.66-.612z"}}),_c('path',{attrs:{"data-name":"Path 7151","d":"M.618 11.923h1.044a.682.682 0 00.66-.486l2.91-9.624a.687.687 0 00-.366-.828A11.7 11.7 0 00.642.001.615.615 0 000 .619v10.686a.617.617 0 00.618.618z"}})])])
          )
        }
      }
    